import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Button } from '@mui/material';

import pageTitle from '../utils/pageTitles.json';
import { BlankCard } from '../components/cards/blankCard';
import KycTitleIcon from '../assets/svgs/kycTitleIcon';
import AnnouncementSvg from '../assets/svgs/announcement';
import IVRSvg from '../assets/svgs/ivr';
import { AnnouncementListTable } from 'src/sections/voice/announcement-ivr/announcementListTable';
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import CampaignIcon from '@mui/icons-material/Campaign';
import CustomModal from 'src/components/modal/customModal';
import BulkAnnouncementForm from 'src/sections/voice/announcement-ivr/bulkAnnouncementForm';
import { checkButtonAccess } from 'src/utils/common';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
  padding: '64px 20px 0px 88px',
  backgroundColor: 'rgb(240, 240, 240)' /* theme.palette.background.default */,
  height: 'calc(100vh - 0px)',
  overflow: 'hidden',
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
  width: '100%',
  padding: '20px 0px 20px 0px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
}));

const DetailsListSection = styled('div')(() => ({
  width: '100%',
  height: 'calc(100vh - 155px)', //'554px',
  overflow: 'hidden',
  overflowY: 'scroll',
}));

const AnnouncementList = ({ type }) => {

  const [openBulkModal, setOpenBulkModal] = useState(false);
  const announcementList = (
    <Box sx={{ width: '100%' }}>
      <DetailsListSection className="reportListScroll">
        <AnnouncementListTable type={type} />
      </DetailsListSection>
    </Box>
  );

  const navigate = useNavigate();

  const handleClick = () => {
    type === 'announcement' ? navigate('/ivrList') : navigate('/announcementList');
  };
  return (
    <>
      <Helmet>
        <title> {type === 'announcement' ? `${pageTitle?.announcement}` : `${pageTitle?.ivr}`} </title>
      </Helmet>

      <MainSection>
        {/* Heading and filters */}
        <HeadingSection>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '10px',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                widht: '16px',
                height: '16px',
                mt: -1.8,
              }}
            >
              {type === 'announcement' ? <AnnouncementSvg /> : <IVRSvg />}
            </Box>
            <Typography variant="h5" sx={{ color: 'grey.10', fontWeight: 600 }}>
              {type === 'announcement' ? 'Announcement List' : 'Ivr List'}
            </Typography>
          </Box>
          <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            startIcon={type === 'announcement' ? <Iconify icon="tabler:binary-tree-2" /> : <CampaignIcon />}
            sx={{
              backgroundColor: 'rgb(33, 43, 54)',
              color: 'grey.100',
              p: '0px 20px 0px 20px',
              '&:hover': {
                backgroundColor: 'rgb(69, 79, 91)',
              },
            }}
            onClick={() => handleClick()}
          >
            {type === 'announcement' ? 'Ivr List' : 'Announcement List'}
          </Button>
          {checkButtonAccess("bulkAnnouncement", "r") && 
          <Button
            startIcon={ <Iconify icon="fluent-mdl2:bulk-upload" /> }
            sx={{
              backgroundColor: 'rgb(33, 43, 54)',
              color: 'grey.100',
              p: '0px 20px 0px 20px',
              '&:hover': {
                backgroundColor: 'rgb(69, 79, 91)',
              },
            }}
            onClick={() => setOpenBulkModal(true)}
          >
            Bulk Announcement Upload
          </Button>
          }
          </Box>
        </HeadingSection>

        <BlankCard
          key="1"
          sx={{
            height: '100%',
            width: '100%',
            padding: '0px',
            overflow: 'hidden',
            // borderTopLeftRadius: '0px',
            // borderTopRightRadius: '0px'
          }}
        >
          {announcementList}
        </BlankCard>
      </MainSection>
      <CustomModal
              open={openBulkModal}
              title="Add Bulk Announcement"
              description={<BulkAnnouncementForm setOpenBulkModal={setOpenBulkModal} />}
              close={() => setOpenBulkModal(false)}
              isCloseIcon={true}
      />
    </>
  );
};

export default AnnouncementList;
